import React, { useEffect, useRef } from "react"
import { Switch, Route, useHistory } from "react-router-dom"

import Header from "../../components/header"
import Sidebar from "../../components/sidebar"
import ErrorContainer from "../Error/404"
import ActivitiesProfileContainer from "./Profile"
import ActivitiesCampaignContainer from "./Campaign"
import CreateCampaignContainer from "./Campaign/Create"

import { useActivities, useActivity } from "../../hooks/useActivities"
import { useSelectedProject } from "../../contexts/SelectedProjectContext"

const ActivitiesContainer: React.FC = () => {
  const history = useHistory()
  const { selectedActivityId, setSelectedActivityId } = useSelectedProject()
  const hasAutoSelected = useRef(false)

  const { data: activitiesData } = useActivities({})
  const activities = activitiesData?.data ?? []

  const { data: selectedActivity } = useActivity(selectedActivityId)

  // Auto-select first activity if none selected
  useEffect(() => {
    if (hasAutoSelected.current) return
    if (!activities.length) return

    if (!selectedActivityId) {
      hasAutoSelected.current = true
      setSelectedActivityId(activities[0].id)
      history.push("/activities/campaigns")
    }
  }, [activities, selectedActivityId, setSelectedActivityId, history])

  // Redirect to create page if no activities
  useEffect(() => {
    if (activitiesData && activities.length === 0) {
      history.push("/activities/create")
    }
  }, [activitiesData, activities.length, history])

  return (
    <>
      <Header />
      <div className="tw-has-header tw-has-sidebar">
        <div className="xl:tw-container tw-mx-auto tw-w-full tw-px-4 sm:tw-px-12">
          <Switch>
            {!activities.length && <Route path="*" component={ErrorContainer} />}
            <Route exact path="/activities/details" component={ActivitiesProfileContainer} />
            <Route exact path="/activities/campaigns" component={ActivitiesCampaignContainer} />
            <Route exact path="/activities/campaigns/create" component={CreateCampaignContainer} />
            <Route path="*" component={ErrorContainer} />
          </Switch>
        </div>
      </div>
      <Sidebar type="activity" selectedProject={selectedActivity} />
    </>
  )
}

export default ActivitiesContainer
